export class BoxLevel {
    constructor(public id: number, public level: number, public created: Date, public updated: Date) {}
}
